import firebase from '../../config/fbConfig'

function GetLogo(logos) {
  switch (logos.dropdown) {
    case 'local':
      UploadFile(logos.localFile)
      return logos.localLabel
    case 'web':
      return logos.webUrl
    default:
      return logos.name
  }
}

function GetLogoWidth(logos) {
  switch (logos.dropdown) {
    case 'local':
      return logos.localWidth
    case 'web':
      return logos.webWidth
    default:
      return ''
  }
}

function UploadFile(file) {
  const storageRef = firebase.storage().ref()
  const imageRef = storageRef.child(file.name)
  imageRef.put(file)
  return `gs://zoom-back.appspot.com/${file.name}`
}

export default function CreateOrder(clientId, info, colors, logos, amount) {
  firebase.firestore().collection('orders').doc(clientId).set({
    name: info.name,
    position: info.position,
    clientId,
    design: {
      textColor: colors.textColor,
      backgroundColor: colors.backgroundColor,
      dropdown: logos.dropdown,
      logo: GetLogo(logos),
      logoColor: colors.logoColor,
      logoWidth: GetLogoWidth(logos),
      watermarkHidden: logos.watermarkHidden
    },
    hasPaid: false,
    price: amount,
    createdAt: new Date()
  }).then(function () {
    console.log('Document successfully written!')
  }).catch(function (error) {
    console.error('Error writing document: ', error)
  })
}
